import { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { getSecondsUntilUpdate } from '../../utils/dayjsUtils';
import useInterval from '../../hooks/useInterval';
import { CalendarOptions } from './interface';
import { getCalenderTime } from './utils';

export interface CalendarProps {
  value: number | Date | Dayjs;
  options?: CalendarOptions;
}

export function Calendar({ value, options = {} }: CalendarProps) {
  const [displayTime, setDisplayTime] = useState(getCalenderTime(value, options));

  const dayjsInstance = dayjs(value);
  const timeToUpdate = getSecondsUntilUpdate(dayjsInstance) * 1000;

  useInterval(() => {
    setDisplayTime(getCalenderTime(value, options));
  }, timeToUpdate);

  return displayTime;
}
